function resetHolsterRedeemBisUi() {
  const bisRoot = document.querySelector('.product-holster-redeem .pdp-back-in-stock-notify');
  if (!bisRoot) return;
  bisRoot.querySelector('.pdp-back-in-stock-notify__message')?.classList.remove('hidden');
  bisRoot.querySelector('.pdp-back-in-stock-notify__form')?.classList.remove('hidden');
  bisRoot.querySelector('.pdp-back-in-stock-notify__success')?.classList.add('hidden');
  const err = bisRoot.querySelector('.pdp-back-in-stock-notify__error');
  if (err) {
    err.classList.add('hidden');
    err.textContent = '';
  }
  const input = bisRoot.querySelector('.pdp-back-in-stock-notify__input');
  if (input) input.value = '';
  const submit = bisRoot.querySelector('.pdp-back-in-stock-notify__submit');
  if (submit) {
    submit.disabled = false;
    const label = bisRoot.dataset.notifyLabel?.trim() || 'Notify me';
    submit.textContent = label;
  }
}

class FindYourDeviceForm extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.fallbackUrl = this.dataset.fallbackUrl || '/';

    this.brandSelect = this.querySelector('[data-role="brand"]');
    this.modelSelect = this.querySelector('[data-role="model"]');
    this.submitButton = this.querySelector('[data-role="submit"]');
    this.errorElement = this.querySelector('[data-role="error"]');
    this.selectedModel = null;

    if (!this.brandSelect || !this.modelSelect || !this.submitButton) return;

    this.data = this.getSectionData();
    if (!this.data.length) return;

    this.init();
  }

  getSectionData() {
    const script = document.getElementById(`device-data-${this.sectionId}`);
    if (!script) return [];
    try {
      return JSON.parse(script.textContent || '[]');
    } catch {
      return [];
    }
  }

  formatCategory(category) {
    return category
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  init() {
    const brandMap = new Map();

    this.data.forEach(item => {
      if (!brandMap.has(item.category_id)) {
        brandMap.set(item.category_id, item.brand);
      }
    });
    
    // Convert to array and sort alphabetically by brand name
    const sortedBrandMap = new Map(
      [...brandMap.entries()].sort((a, b) =>
        (a[1] || '').localeCompare(b[1] || '', undefined, {
          sensitivity: 'base',
          numeric: true
        })
      )
    );

    sortedBrandMap.forEach((brandName, categoryId) => {
      const option = document.createElement('option');
      option.value = categoryId;
      option.textContent = brandName;
      this.brandSelect.appendChild(option);
    });

    this.brandSelect.addEventListener('change', this.handleBrandChange.bind(this));
    this.modelSelect.addEventListener('change', this.handleModelChange.bind(this));
    this.submitButton.addEventListener('click', this.handleSubmit.bind(this));
  }

  handleBrandChange() {
    const selectedCategory = this.brandSelect.value;

    this.modelSelect.innerHTML = `<option value="">${Theme.translations?.select_device}</option>`;
    this.modelSelect.disabled = !selectedCategory;
    this.submitButton.disabled = true;

    if (!selectedCategory) return;

    const models = this.data
      .filter(item => item.category_id === selectedCategory)
      .sort((a, b) => a.display_name.localeCompare(b.display_name));

    models.forEach(model => {
      const option = document.createElement('option');
      option.value = model.id;
      option.dataset.url = model.target_url || '';
      option.textContent = model.display_name;
      this.modelSelect.appendChild(option);
    });
  }

  handleModelChange() {
    if (this.closest('.product-holster-details')) {
      let variantInput = this.querySelector('.holster-variant-id');
      let selectedOptionValue = this.modelSelect.selectedOptions[0].value;
      let variant = this.data.find(device => device.id === selectedOptionValue);
      let claimButton = document.querySelector('.product-holster-redeem__button');
      let applyPromoButton = document.querySelector('.add-promo-code__button');
      let bisWrapper = document.querySelector('.product-holster-redeem__bis');
      let bisNotify = document.querySelector('.product-holster-redeem .pdp-back-in-stock-notify');
      resetHolsterRedeemBisUi();
      if (variant.holster_variant) {
        document.querySelector('redeem-now-component')?.classList.remove('hidden');
        variantInput.value = variant.holster_variant.id;
        variantInput.dataset.available = variant.holster_variant.available;
        if (bisNotify) bisNotify.dataset.variantId = String(variant.holster_variant.id);
        const redeemDisabled = !variant.holster_variant.available;
        if (claimButton) claimButton.disabled = redeemDisabled;
        if (applyPromoButton) applyPromoButton.disabled = redeemDisabled;
        if (variant.holster_variant.available) {
          if (bisWrapper) bisWrapper.classList.add('hidden');
          document.querySelector('redeem-now-component')?.classList.remove('hidden');
          if (variant.holster_variant.product_handle && claimButton) {
            claimButton.dataset.targetUrl = this.holsterProductUrl(variant.holster_variant.product_handle, variantInput.value);
          }
        } else {
          if (bisWrapper) bisWrapper.classList.remove('hidden');
          document.querySelector('redeem-now-component')?.classList.add('hidden');
        }
      } else {
        variantInput.value = '';
        variantInput.dataset.available = false;
        if (bisNotify) bisNotify.dataset.variantId = '';
        if (claimButton) claimButton.disabled = true;
        if (applyPromoButton) applyPromoButton.disabled = true;
        if (bisWrapper) bisWrapper.classList.add('hidden');
        document.querySelector('redeem-now-component')?.classList.add('hidden');
      }
    } else {
      const selectedOption = this.modelSelect.selectedOptions[0];
      const url = selectedOption?.dataset?.url;
  
      this.submitButton.disabled = !url;
  
      if (url) {
        const prefetch = document.createElement('link');
        prefetch.rel = 'prefetch';
        prefetch.href = url;
        document.head.appendChild(prefetch);
      }
    }
  }

  handleSubmit() {
    const selectedOption = this.modelSelect.selectedOptions[0];
    const url = selectedOption?.dataset?.url;

    if (!url) {
      if (this.errorElement) {

        this.errorElement.textContent = Theme.translations?.select_model_error || 'Please select a model.';
      }
      return;
    }

    window.location.href = url || this.fallbackUrl;
  }

  /**
  * @param {string} productHandle
  * @param {string | number} variantId
  */
  holsterProductUrl(productHandle, variantId) {
    const query = new URLSearchParams({ variant: String(variantId) }).toString();
    return `/products/${encodeURIComponent(productHandle)}?${query}`;
  }
}

if (!customElements.get('find-your-device-form')) {
  customElements.define('find-your-device-form', FindYourDeviceForm);
}
